export default "__VITE_ASSET__DoBuL$Rg__"